module.exports = "/lucky-balls/img/yellow-ball.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/yellow-ball.png
// module id = 104
// module chunks = 0